import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Alerts = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.5 145.05c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5-51 1.567-51 3.5 22.834 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M108.743 125.641C98.103 134.601 84.361 140 69.356 140c-10.04 0-19.515-2.418-27.874-6.702-.642-.738-.982-1.507-.982-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M108.743 125.641C98.103 134.601 84.361 140 69.356 140c-10.04 0-19.515-2.418-27.874-6.702-.642-.738-.982-1.507-.982-2.298 0-5.523 16.566-10 37-10 13.139 0 24.678 1.851 31.243 4.641Z"
      />
      <path
        fill="#D9D9D9"
        fillRule="evenodd"
        d="m57.678 138.937 11.711-3.186c3.098-.843 4.155-4.762 1.913-7.09l-16.687-17.327c-2.286-2.374-6.25-1.296-7.062 1.921l-5.178 20.542a60.79 60.79 0 0 0 15.303 5.14Zm.805-6.832c.3 1.136-.364 2.303-1.483 2.608-1.118.304-2.268-.37-2.568-1.506-.3-1.135.364-2.303 1.483-2.607 1.12-.305 2.268.369 2.568 1.505Zm-6.367-15.901c-1.119.305-1.783 1.472-1.483 2.608l1.628 6.169c.3 1.136 1.45 1.81 2.57 1.506 1.117-.305 1.781-1.472 1.481-2.608l-1.628-6.169c-.3-1.136-1.45-1.81-2.568-1.506Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        fillRule="evenodd"
        d="m57.678 138.937 11.711-3.186c3.098-.843 4.155-4.762 1.913-7.09l-16.687-17.327c-2.286-2.374-6.25-1.296-7.062 1.921l-5.178 20.542a60.79 60.79 0 0 0 15.303 5.14Zm.805-6.832c.3 1.136-.364 2.303-1.483 2.608-1.118.304-2.268-.37-2.568-1.506-.3-1.135.364-2.303 1.483-2.607 1.12-.305 2.268.369 2.568 1.505Zm-6.367-15.901c-1.119.305-1.783 1.472-1.483 2.608l1.628 6.169c.3 1.136 1.45 1.81 2.57 1.506 1.117-.305 1.781-1.472 1.481-2.608l-1.628-6.169c-.3-1.136-1.45-1.81-2.568-1.506Z"
        clipRule="evenodd"
      />
      <path
        fill="#D9D9D9"
        d="M57 134.713c1.12-.305 1.783-1.472 1.483-2.608-.3-1.136-1.449-1.81-2.568-1.505-1.119.304-1.783 1.472-1.483 2.607.3 1.136 1.45 1.81 2.568 1.506Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M57 134.713c1.12-.305 1.783-1.472 1.483-2.608-.3-1.136-1.449-1.81-2.568-1.505-1.119.304-1.783 1.472-1.483 2.607.3 1.136 1.45 1.81 2.568 1.506Z"
      />
      <path
        fill="#D9D9D9"
        d="M57 134.713c1.12-.305 1.783-1.472 1.483-2.608-.3-1.136-1.449-1.81-2.568-1.505-1.119.304-1.783 1.472-1.483 2.607.3 1.136 1.45 1.81 2.568 1.506ZM50.633 118.812c-.3-1.136.364-2.303 1.483-2.608 1.118-.304 2.268.37 2.568 1.506l1.628 6.169c.3 1.136-.364 2.303-1.482 2.608-1.119.304-2.269-.37-2.569-1.506l-1.628-6.169Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M50.633 118.812c-.3-1.136.364-2.303 1.483-2.608 1.118-.304 2.268.37 2.568 1.506l1.628 6.169c.3 1.136-.364 2.303-1.482 2.608-1.119.304-2.269-.37-2.569-1.506l-1.628-6.169Z"
      />
      <path
        fill="#D9D9D9"
        d="M50.633 118.812c-.3-1.136.364-2.303 1.483-2.608 1.118-.304 2.268.37 2.568 1.506l1.628 6.169c.3 1.136-.364 2.303-1.482 2.608-1.119.304-2.269-.37-2.569-1.506l-1.628-6.169Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.816 124.85c.28-.248.556-.497.83-.748a.501.501 0 0 0-.316-.868.495.495 0 0 0-.36.131 63.969 63.969 0 0 1-1.646 1.457.51.51 0 0 0-.186.343.51.51 0 0 0 .118.373.495.495 0 0 0 .717.044c.283-.241.564-.485.843-.732Zm3.274-4.556a.497.497 0 0 0-.105.555.495.495 0 0 0 .672.251.492.492 0 0 0 .159-.119 61.377 61.377 0 0 0 4.316-5.089.499.499 0 0 0-.466-.798.503.503 0 0 0-.331.193 60.455 60.455 0 0 1-4.245 5.007Zm-9.417 9.343a.494.494 0 0 0 .21-.321.512.512 0 0 0-.079-.374.504.504 0 0 0-.515-.208.522.522 0 0 0-.18.077 60.106 60.106 0 0 1-3.7 2.336.503.503 0 0 0-.181.684.502.502 0 0 0 .684.181 62.11 62.11 0 0 0 3.761-2.375Zm-5.706 3.46a.501.501 0 0 0-.093-.915.5.5 0 0 0-.377.033c-18.15 9.695-39.99 9.416-57.776-.37a.502.502 0 0 0-.728.577.494.494 0 0 0 .246.299c18.08 9.947 40.277 10.232 58.729.376Zm24.138-25.146a.509.509 0 0 0 .048.554.488.488 0 0 0 .529.168.507.507 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.498.498 0 0 0-.676-.207.498.498 0 0 0-.207.677c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.503.503 0 0 0 .684.18.5.5 0 0 0 .181-.683 60.79 60.79 0 0 0-2.374-3.762.5.5 0 1 0-.826.564 60.066 60.066 0 0 1 2.335 3.7Zm-89.689 79.612a.52.52 0 0 0 .37.097.504.504 0 0 0 .428-.564.496.496 0 0 0-.194-.33 60.521 60.521 0 0 1-5.007-4.244.504.504 0 0 0-.35-.117.504.504 0 0 0-.473.5.5.5 0 0 0 .136.344 61.529 61.529 0 0 0 5.09 4.314Zm-8.212-7.484a.497.497 0 0 0 .868-.317.5.5 0 0 0-.13-.359 69.981 69.981 0 0 1-.7-.776C2.46 93.87 4.83 55.582 29.905 33.397c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.503.503 0 0 0 .147-.547.485.485 0 0 0-.103-.171 55.36 55.36 0 0 0-.661-.763l-.036-.04-.035-.04a61.688 61.688 0 0 0-3.805-3.926.503.503 0 0 0-.064-.073 61.353 61.353 0 0 0-5.091-4.314.48.48 0 0 0-.128-.071 61.021 61.021 0 0 0-7.186-4.653.5.5 0 0 0-.147-.12c-18.08-9.95-40.278-10.234-58.728-.377a.5.5 0 0 0-.22.237c-.472.255-.94.516-1.407.785a.498.498 0 0 0-.318.063 61.565 61.565 0 0 0-3.761 2.375.498.498 0 0 0-.195.262 62.226 62.226 0 0 0-4.8 3.673.498.498 0 0 0-.306.12 63.74 63.74 0 0 0-1.672 1.48.5.5 0 0 0-.156.288 62.411 62.411 0 0 0-2.724 2.682.499.499 0 0 0-.29.15 61.682 61.682 0 0 0-4.316 5.09.499.499 0 0 0-.102.308 61.26 61.26 0 0 0-4.513 6.935.499.499 0 0 0-.234.215C6.04 67.068 5.733 89.266 15.574 107.71c.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.048.03.094.055.136a62.01 62.01 0 0 0 2.373 3.763.505.505 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.035.04.008.008c.221.25.443.497.67.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M1 16h88v85H1V16Z" />
      <path stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.99 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.99 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM82.99 30.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 39.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 48.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 57.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 66.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.99 75.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.767 21H26.395a.905.905 0 0 0 0 1.81h12.372a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M83.085 21h-5.281a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.221 21H68.94a.905.905 0 0 0 0 1.81h5.281a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.449 24.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.216c7.403 0 13.404-5.996 13.404-13.393S96.517 86.43 89.114 86.43 75.71 92.426 75.71 99.823s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.217c7.403 0 13.404-5.997 13.404-13.394S96.517 86.43 89.114 86.43 75.71 92.426 75.71 99.823s6.001 13.394 13.404 13.394Zm1.676-18.416a1.676 1.676 0 0 0-3.351 0v3.348h-3.351a1.675 1.675 0 1 0 0 3.348h3.35v3.349a1.674 1.674 0 0 0 1.676 1.676 1.677 1.677 0 0 0 1.676-1.676v-3.349h3.35a1.674 1.674 0 1 0 0-3.348h-3.35v-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="m86.43 27.703.22-.22V17.85C86.65 9.649 93.298 3 101.5 3c8.201 0 14.85 6.649 14.85 14.85v9.633l.219.22 1.839 1.839a1.844 1.844 0 0 1 .401 2.016A1.85 1.85 0 0 1 117.1 32.7H85.9a1.85 1.85 0 0 1-1.308-3.158l1.838-1.839ZM101.5 43.1a7.051 7.051 0 0 1-7.01-6.3h14.02a7.046 7.046 0 0 1-7.01 6.3Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="m86.43 27.703.22-.22V17.85C86.65 9.649 93.298 3 101.5 3c8.201 0 14.85 6.649 14.85 14.85v9.633l.219.22 1.839 1.839a1.844 1.844 0 0 1 .401 2.016A1.85 1.85 0 0 1 117.1 32.7H85.9a1.85 1.85 0 0 1-1.308-3.158l1.838-1.839ZM101.5 43.1a7.051 7.051 0 0 1-7.01-6.3h14.02a7.046 7.046 0 0 1-7.01 6.3Z"
      />
      <path
        stroke={primary}
        d="m86.43 27.703.22-.22V17.85C86.65 9.649 93.298 3 101.5 3c8.201 0 14.85 6.649 14.85 14.85v9.633l.219.22 1.839 1.839a1.844 1.844 0 0 1 .401 2.016A1.85 1.85 0 0 1 117.1 32.7H85.9a1.85 1.85 0 0 1-1.308-3.158l1.838-1.839ZM101.5 43.1a7.051 7.051 0 0 1-7.01-6.3h14.02a7.046 7.046 0 0 1-7.01 6.3Z"
      />
      <path
        fill={primary}
        d="M126.5 16.55c0-6.351-5.149-11.5-11.5-11.5s-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5 11.5-5.149 11.5-11.5Z"
      />
      <path
        stroke={primary}
        strokeWidth="2"
        d="M126.5 16.55c0-6.351-5.149-11.5-11.5-11.5s-11.5 5.149-11.5 11.5 5.149 11.5 11.5 11.5 11.5-5.149 11.5-11.5Z"
      />
      <path
        fill="#D9D2E5"
        d="M117.906 21.05h-5.801v-1.037l2.221-2.25c.43-.438.783-.815 1.06-1.131.278-.32.483-.623.616-.908.136-.285.205-.596.205-.932 0-.414-.119-.726-.358-.937-.238-.215-.552-.323-.943-.323-.371 0-.715.075-1.031.223a4.78 4.78 0 0 0-.973.621l-.756-.908c.238-.203.492-.389.762-.557.273-.168.578-.3.914-.398a3.97 3.97 0 0 1 1.148-.152c.543 0 1.012.097 1.407.293.394.19.697.459.908.802.215.344.322.744.322 1.201 0 .461-.092.887-.275 1.278-.184.39-.446.777-.785 1.16-.34.379-.745.79-1.213 1.236l-1.483 1.448v.064h4.055v1.207Z"
      />
      <path
        fill="#fff"
        d="M121.5 70.05a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1v-15Z"
      />
      <path
        fill={primary}
        d="M121 71.05a2.5 2.5 0 0 1 2.5-2.5h13a2.501 2.501 0 0 1 2.5 2.5h-1a1.501 1.501 0 0 0-1.5-1.5h-13a1.502 1.502 0 0 0-1.5 1.5h-1Zm0 5v-5a2.5 2.5 0 0 1 2.5-2.5v1a1.502 1.502 0 0 0-1.5 1.5v5h-1Zm15.5-7.5a2.501 2.501 0 0 1 2.5 2.5v5h-1v-5a1.501 1.501 0 0 0-1.5-1.5v-1Zm-13 3.75h4.179v.5H123.5v-.5Z"
      />
      <path
        stroke={primary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth=".3"
        d="M135.375 73.175H136l-.176-.176a.251.251 0 0 1-.074-.18v-.394a.747.747 0 0 0-.5-.707v-.043a.25.25 0 1 0-.5 0v.043a.747.747 0 0 0-.5.707v.395a.252.252 0 0 1-.075.18l-.175.175h.625m.75 0v.125a.377.377 0 0 1-.375.375.375.375 0 0 1-.375-.375v-.125m.75 0h-.75"
      />
      <path
        stroke={primary}
        d="M121.5 76.05h17v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2v-8Z"
      />
      <path fill={primary} d="M125.5 78.05h9v2h-9v-2Z" />
      <path fill="#DDDBDF" d="M124.5 82.05h11v2h-11v-2Z" />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.43"
          y2="113.217"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Alerts;
